module.exports = __webpack_public_path__ + "static/media/YF103_2.f91b2f50.jpg";